import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const IconLight = ({ icon, style, className, border, flip }) => {
  return (
    <FontAwesomeIcon
      icon={["fal", icon]}
      className={className}
      style={style}
      border={border}
      flip={flip}
    />
  );
};

IconLight.propTypes = {
  icon: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  border: PropTypes.bool,
  flip: PropTypes.string
};

export default IconLight;



// WEBPACK FOOTER //
// ./src/views/components/icon_light/IconLight.jsx